import { u, styled } from '../../../../shared/theming-sc'

const NoResults = styled.td`
    text-align: center;
    padding: ${u.getSpacing('small')}px;
`

const ClearLink = styled.a`
    color: ${u.getColor('greyDark')};
    text-decoration: underline;

    &:hover {
        color: ${u.getColor('greyDark')};
    }
`

export {
  NoResults,
  ClearLink
}
